<template>
  <div class="national-m-sub">
    <img
      class="main-logo"
      :src="require('../../assets/img/horizontal-black-scroll-icon.png')"
      alt="메인로고"
    />
    <span class="m-sub-content"
      ><span class="black">좌우로 스크롤</span>하여 확인해보세요.</span
    >
  </div>
</template>

<script>
export default {
  name: "MobileScroll",
};
</script>

<style scoped>
.national-m-sub {
  text-align: left;
  display: none;
  margin-bottom: 30px;
  align-items: center;

  & img {
    margin-right: 21px;
  }

  @media only screen and (max-width: 1040px) {
    display: flex;
  }
}

.m-sub-content {
  font-family: GmarketSansMedium;
  font-size: 26px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666;

  & .black {
    color: #000;
  }

  @media only screen and (max-width: 528px) {
    font-size: 20px;
  }
}
</style>
